import { isOwnRequestId } from '~/utils/turbo_request_ids'

// The semantics of Turbo's built-in `refresh` action minus the automatic visit:
// the author picks the moment to repaint, not the server. In a builder with an
// editor open, pulling the DOM out from under the author's hands is worse than
// showing a notice.
export function staleStreamAction () {
  const container = document.getElementById(this.target)
  if (!container) return

  if (isOwnRequestId(this.getAttribute('request-id'))) return

  // A second notice says nothing the first did not, and replacing the node
  // would tear down and rebuild the Stimulus controller behind the Reload
  // button for no reason.
  if (container.firstElementChild) return

  container.appendChild(this.templateContent)
}
